import { render, staticRenderFns } from "./ElectricVehicleOwnership.vue?vue&type=template&id=9c0b6a6e"
import script from "./ElectricVehicleOwnership.vue?vue&type=script&lang=js"
export * from "./ElectricVehicleOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports